import { render, staticRenderFns } from "./FloorPhysicsAssociationMeasureEdit.vue?vue&type=template&id=8b537802&"
import script from "./FloorPhysicsAssociationMeasureEdit.vue?vue&type=script&lang=js&"
export * from "./FloorPhysicsAssociationMeasureEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports